<template>
    <div>
        <div class="remote-select">
            <ESelect v-bind="$attrs" remote filterable @input="handleInput"
                :loading="loading" style="flex: 1" :disabled="isDisabled" ref="select" @visible-change="handleVisibleChange">
                <el-option v-for="item in options" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
            </ESelect>
            <el-button v-if="isBatch" :disabled="isDisabled" class="ml20" type="primary" size="small"
                @click="handleBatchSelect">
                批量添加
            </el-button>
        </div>
        <p class="mt10 font12px" style="color: #666;">可选产品来源于【客户产品管理】模块，已经绑定至目标账户对应客户且是启用状态的产品</p>
        <!-- <div v-if="validate_options.length">
            <div class="mt10">
                <p class="font12px">
                    <span style="color: #ff0000;">{{ validate_options.length ? get_validate_options() : '暂无' }}</span>
                    当前产品有问题，请点击验证后根据右上角提示去完善，完善后点击更新，更新最新的产品状态
                </p>
            </div>
            <div class="mt10">
                <el-button type="primary" @click="handleVali">验证</el-button>
                <el-button @click="handleUpdate">更新</el-button>
            </div>
        </div> -->

    </div>
</template>

<script>
import { batchSelectModal } from '@/components/modal/index.js'
import _ from 'lodash'
import { getBatchCheckProductnApi, getBatchAppListApi } from '@/api/marketManage/huaweiAds.js'
import busMixin from '@/views/mixins/busMixin'
export default {
    inheritAttrs: false,
    name: 'AdsRemoteSelect',
    mixins: [busMixin],
    props: {
        isBatch: Boolean,
        initial: String,
        rootFormData: Object,
        formState: {
            type: Object,
            default: null
        },
        fetch_type: {
            type: String,
            default: 'get'
        },
        fetch_url: {
            type: String,
            default: ''
        },
        params: {
            type: [Array, Object],
            default: () => {
                return {};
            }
        },
        field: {
            type: String,
        }
    },
    data() {
        return {
            options: [],
            loading: false,
            validate_options: [],
            cache_options: [],
        }
    },
    computed: {
        dependencies() {
            return this.rootFormData && _.pick(this.rootFormData, this.params)
        },
        isDisabled() {
            return _.isEmpty(this.rootFormData.account_id) || _.isNull(this.rootFormData.account_id);
        }
    },
    watch: {
        dependencies: {
            handler(newVal, oldVal) {
                if (_.isEqual(newVal, oldVal)) {
                    return;
                }
                if(newVal && oldVal) {
                    this.$set(this.formState.payload, 'value', [])
                }
                this.options = []
                this.$nextTick(() => {
                    this.handleInitEffects()
                })
            },
            deep: true,
            immediate: true
        },
        isDisabled: {
            handler(newVal) {
                if (newVal) {
                    this.formState.payload.value = []
                }
            }
        }
    },
    mounted() {
    },
    methods: {
        get_validate_options() {
            return this.validate_options.map(item => item.label).join(',')
        },
        handleVisibleChange(visible) {
            if (!visible) {
                // this.options = this.cache_options
                this.fetchData('')
            }
        },
        handleBatchSelect() {
            const onSubmit = (data) => {
                console.log('data:', data);
                if(!data.length) {
                    return this.$message.error('批量添加不可为空')
                }
                let res_data = _.uniqBy(data)
                this.batchSelectModal(res_data, delErrList, vm)
            };
            const { vm, delErrList } = batchSelectModal({
                title: '批量添加',
                props: {
                    tip: '输入或粘贴ID，每行一个',
                },
                cbs: {
                    onSubmit
                }
            })

        },
        remoteMethod: _.throttle(async function (search) {
            if (_.isEmpty(search)) {
                return;
            }
            await this.fetchData(search)
        }, 300),
        batchSelectModal(search, delErrList, vm) {
            let _this = this;
            const params = _.assign({}, this.dependencies, { search:search.join(',') })
            getBatchAppListApi(params).then(res => {
                let res_options = res.data?.list.splice(0, 200) || [];
                if (res.data?.err_list?.length) {
                    let err_list = res.data?.err_list || [];
                    delErrList({
                        tip: `未找到以下产品，请检查输入的ID是否准确，或检查是否已经绑定至目标账户对应客户且是启用状态，是否需要剔除未找到的产品？`,
                        list: err_list,
                        onOk() {
                            _this.cbList(res_options);
                            vm.close()
                        },
                        colse() { }
                    })
                } else {
                    _this.cbList(res_options);
                    vm.close()
                }
            })

        },
        cbList(list) {
            // 取出已经存在的产品
            this.options = _.uniqBy([...this.options, ...list], 'value')
            this.formState.payload.value = _.uniq(_.concat(this.formState.payload.value, list.map(item => item.value)))

            // 为了取点汉字用  其它啥也没干 !this.formState.payload.props.defaultData?.length 
            if (Array.isArray(this.rootFormData[this.formState.payload.field])) {
                this.$set(this.formState.payload.props, 'defaultData', this.options.filter(item => this.formState.payload.value.includes(item.value)))
            }
        },
        async fetchData(search) {
            this.loading = true;
            const params = _.assign({}, this.dependencies, { search })
            const res = await getBatchAppListApi(params)
            if (res?.code != 200) {
                return this.$message.error(res?.info || '获取数据失败')
            }
            let res_options = res.data?.list || []
            this.options = res_options

            // 为了取点汉字用  其它啥也没干
            if (Array.isArray(this.rootFormData[this.formState.payload.field])) {
                this.$set(this.formState.payload.props, 'defaultData', this.options.filter(item => this.formState.payload.value.includes(item.value)))
            }
            this.loading = false;
        },
        // 处理当前表单项依赖的表单项值变化，如果当前字段有默认值，直接走接口赋值
        handleInitEffects() {
            if (!_.isNull(this.rootFormData[this.formState.payload.field]) && !_.isEmpty(this.rootFormData[this.formState.payload.field])) {
                let value = Array.isArray(this.rootFormData[this.formState.payload.field]) ? this.rootFormData[this.formState.payload.field].join(',') : this.rootFormData[this.formState.payload.field];
                this.fetchData('')
                return;
            }
            this.fetchData('')
        },
        handleInput(val) {
            // 为了取点汉字用  其它啥也没干
            const values = _.toArray(val)
            const defaultValue = _.filter(this.formState.payload.props.defaultData || [], (item) => values.includes(item.value));
            const options = this.options;
            const list = _.differenceBy(options, defaultValue, 'value');
            this.formState.payload.props.defaultData = _.concat(_.filter(list, (item) => (values.includes(item.value))), defaultValue)
            // let all_list = _.concat(_.filter(list, (item) => (values.includes(item.value))), defaultValue)
            // let list_status_success = _.filter(all_list, (item) => item.status == '1')
            // let list_status_error = _.filter(all_list, (item) => item.status == '2')
            // this.formState.payload.props.defaultData = list_status_success
            // this.validate_options = list_status_error

            this.$emit('input', val)
        },
        handleVali() {
            let ids = this.validate_options.map(item => item.value).join(',')
            let router_ids = this.validate_options.map(item => item.show_id).join(',')
            getBatchCheckProductnApi({
                plat_id: 10,
                account_id: this.rootFormData.account_id,
                value: ids
            }).then(res => {
                let name_list = this.validate_options.map(item => (`<p>${item.label}</p>`)).join('')
                let flag_html = `<div><h4>以下产品存在问题</h4><div style="max-height: 50vh;overflow-y: auto">${name_list}</div><div style="text-align: right;">
                    <el-button style="background-color: rgb(98, 175, 255); padding: 4px 8px;color: #fff;border-radius: 3px;cursor: pointer;" id="adsToPages">去验证</el-button>
                    </div></div>`
                this.$notify.closeAll();
                this.$notify({
                    title: '警告',
                    type: 'warning',
                    dangerouslyUseHTMLString: true,
                    message: flag_html,
                    duration: 60 * 1000
                });
                let ele_button = document.getElementById('adsToPages')
                ele_button && ele_button.addEventListener('click', () => {
                    const route = this.$router.resolve({ name: 'customer_app_management_new', query: { type: 'subproject_id', ids: router_ids } });
                    window.open(route.href, '_blank');
                })

                // this.handleUpdate()

            }).catch(err => {
                this.$message.error(err.info)
            })

        },
        handleUpdate: _.throttle(async function () {
            if (_.isEmpty(this.rootFormData[this.formState.payload.field])) {
                this.$message.error('请先选择产品')
                return;
            }
            await this.fetchData(this.rootFormData[this.formState.payload.field])
        }, 5 * 1000),
    }
}
</script>

<style lang="scss" scoped>
.remote-select {
    display: flex;
    align-items: center;
}
</style>